import React from "react";

import moment from "moment";

import { getCurrentPlatformTermsAndConditions } from "services";

import { formatDate, openFileInNewTab, useGetLatestPlatformContract, useTranslation } from "utils";

import { USER_TYPE, userType } from "models";

import { Checkbox, Flex, GuidanceLink, Typography } from "components";

type PlatformTermsProps = {
  userType: userType;
  checkboxState: boolean;
  setCheckboxState: (state: boolean) => void;
};

export const PlatformTerms = ({ userType, checkboxState, setCheckboxState }: PlatformTermsProps) => {
  const { t } = useTranslation("dashboard");
  const platformContract = useGetLatestPlatformContract();

  const handlePlatformTermsClick = async () => {
    const data = await getCurrentPlatformTermsAndConditions();
    openFileInNewTab(data);
  };

  return (
    <Flex vertical gap="0.5rem">
      <Flex className="margin-top-250" align="center" gap="0.25rem">
        {userType === USER_TYPE.EXISTING && <Checkbox checked={checkboxState} onClick={() => setCheckboxState(!checkboxState)} />}
        <Typography variant="h3">{t("termsOverlay.platformTerms")}</Typography>
      </Flex>
      {userType === USER_TYPE.EXISTING && platformContract.data?.createdAt && (
        <Typography variant="paragraph-m">
          {t("termsOverlay.deadline", {
            createdAt: formatDate(platformContract.data?.createdAt, "LL", moment.ISO_8601),
            signBy: formatDate(
              moment(platformContract.data?.createdAt)
                .add(30, "days")
                .toISOString(),
              "LL",
              moment.ISO_8601
            ),
          })}
        </Typography>
      )}
      <Typography variant="paragraph-m" style={{ whiteSpace: "pre-line" }}>
        {userType === USER_TYPE.NEW ? t("termsOverlay.newUser.platformTermsDescription") : platformContract.data?.description}
      </Typography>
      <Flex align="center">
        <Typography variant="paragraph-m">{t("termsOverlay.linkDescription")}</Typography>
        <GuidanceLink text={t("termsOverlay.platformTermsLink")} onClick={handlePlatformTermsClick} />
      </Flex>
    </Flex>
  );
};

export default PlatformTerms;
